'use strict';

const $search = $('.c-header__search');
const $overlay = $('.c-header__overlay');
const $toggle = $('.c-header__search-toggle');
const $body = $(document);

$toggle.on('click', function(e) {
    e.preventDefault();

    // show overlay and position it.
    const offset = $('.c-header__left-content').outerHeight();
    const height = $body.height() - offset;
    $overlay.css({
        'height': height + 'px',
        'top': offset + 'px'
    });

    if($('.c-header__menu-toggle').hasClass('is-active')) {
        //close menu if active
        $('.c-header__menu-toggle').trigger('click');
    }

    toggleItems();
});

function toggleItems() {
    if($toggle.hasClass('is-active')) {

        $toggle.removeClass('is-active');
        $search.removeClass('is-active');
        $overlay.removeClass('is-active');
        // stop watching body click
        $(document).off('click', watchBodyClick);

    } else {

        $toggle.addClass('is-active');
        $search.addClass('is-active');
        $overlay.addClass('is-active');
        // start watching body click
        $(document).on('click', watchBodyClick);
    }
}

function watchBodyClick(e) {
    if(!$(e.target).closest('.c-header__search').length && !$(e.target).closest('.c-header__search-toggle').length ) {
        if($toggle.hasClass('is-active')) {
            toggleItems();
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/components/search-toggle.js